import { StyledMetaversePopupTitle } from './MetaversePopupTitle.styled';

const MetaversePopupTitle = ({ forHomePage = false }) => {
  return (
    <StyledMetaversePopupTitle>
      <div className='metaverse-popup-title' style={{backgroundImage: forHomePage ? "url(/assets/metaverse_header.png)" : undefined, backgroundSize: forHomePage ? 'cover' : undefined}}>
        <div>
          Explore thousands of worlds, games and platforms with<br/><span className='metaverse-popup-title-text-bold'>Your Avatar</span>
        </div>
        {!forHomePage && <img src='/assets/metaverse_title_logo.svg'/>}
      </div>
    </StyledMetaversePopupTitle>
  );
};

export default MetaversePopupTitle;
